module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showtitle) ? _c('div', {
    staticClass: "joinbx text-center"
  }, [_c('div', {
    staticClass: "row",
    class: _vm.customClass
  }, [_c('div', {
    staticClass: "col-3 text-center"
  }, [_c('a', {
    staticClass: "nonecolor",
    attrs: {
      "href": "https://www.facebook.com/SouledStore",
      "aria-label": "Facebook",
      "rel": "noopener noreferrer",
      "target": "_blank"
    },
    on: {
      "click": _vm.facebookClick
    }
  }, [_c('div', {
    staticClass: "circle-icon fbook",
    class: _vm.sizeicon
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('small', [_vm._v("Facebook  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('a', {
    staticClass: "nonecolor",
    attrs: {
      "href": "https://www.instagram.com/TheSouledStore/",
      "aria-label": "Instagram",
      "rel": "noopener noreferrer",
      "target": "_blank"
    },
    on: {
      "click": _vm.instagramClick
    }
  }, [_c('div', {
    staticClass: "circle-icon instagram",
    class: _vm.sizeicon
  }, [_c('span', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('small', [_vm._v("Instagram")])])]), _vm._v(" "), (_vm.callerComp === 'contact-us') ? _c('div', {
    staticClass: "col-3"
  }, [_c('a', {
    staticClass: "nonecolor",
    attrs: {
      "href": "https://www.youtube.com/channel/UC1LkdB8GTrMEwFF_yzqytoA",
      "aria-label": "Youtube",
      "rel": "noopener noreferrer",
      "target": "_blank"
    },
    on: {
      "click": _vm.snapchatClick
    }
  }, [_c('div', {
    staticClass: "circle-icon youtube",
    class: _vm.sizeicon
  }, [_c('span', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('small', [_vm._v("Youtube")])])]) : _c('div', {
    staticClass: "col-3"
  }, [_c('a', {
    staticClass: "nonecolor",
    attrs: {
      "href": "https://www.snapchat.com/add/thesouledstore",
      "rel": "noopener noreferrer",
      "aria-label": "Snapchat",
      "target": "_blank"
    },
    on: {
      "click": _vm.snapchatClick
    }
  }, [_c('div', {
    staticClass: "circle-icon snapchat",
    class: _vm.sizeicon
  }, [_c('span', {
    staticClass: "fa fa-snapchat"
  })]), _vm._v(" "), _c('small', [_vm._v("Snapchat")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('a', {
    staticClass: "nonecolor ",
    attrs: {
      "href": "https://twitter.com/TheSouledStore",
      "rel": "noopener noreferrer",
      "aria-label": "Twitter",
      "target": "_blank"
    },
    on: {
      "click": _vm.twitterClick
    }
  }, [_c('div', {
    staticClass: "circle-icon  x-twitter",
    class: _vm.sizeicon
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('small', [_vm._v("X")])])])])]) : _c('div', {
    staticClass: "joinbx text-center"
  }, [_c('a', {
    staticClass: "nonecolor circle-icon fbook ",
    class: _vm.sizeicon,
    attrs: {
      "href": "https://www.facebook.com/SouledStore",
      "aria-label": "Facebook",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook",
    on: {
      "click": _vm.facebookClick
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "nonecolor circle-icon instagram ",
    class: _vm.sizeicon,
    attrs: {
      "href": "https://www.instagram.com/TheSouledStore/",
      "aria-label": "Instagram",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": _vm.instagramClick
    }
  }, [_c('span', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "nonecolor circle-icon snapchat ",
    class: _vm.sizeicon,
    attrs: {
      "href": "https://www.snapchat.com/add/thesouledstore",
      "aria-label": "Snapchat",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": _vm.snapchatClick
    }
  }, [_c('span', {
    staticClass: "fa fa-snapchat"
  })]), _vm._v(" "), _c('a', {
    staticClass: "nonecolor circle-icon x-twitter ",
    class: _vm.sizeicon,
    attrs: {
      "href": "https://twitter.com/TheSouledStore",
      "aria-label": "X",
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": _vm.twitterClick
    }
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3be1f728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/followsWithsocial.vue
// module id = 1220
// module chunks = 2 37 42 48